import { StringFormatExtention } from "by/gamefactory/extensions/StringFormatExtention";
import { TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { UpgradeResourcePackage } from "../resources/UpgradeResourcePackage";
import { ButtonWithTextAndIcon } from "../../../common/components/ButtonWithTextAndIcon";
import { UpgradeStateType } from "./UpgradeStateType";

export class UpgradeCoinButton extends ButtonWithTextAndIcon {
    public readonly upgradeStateType: UpgradeStateType;
    private readonly upgradeResources: UpgradeResourcePackage;

    public constructor(
        upgradeResources: UpgradeResourcePackage,
        upgradeStateType: UpgradeStateType,
        coinsCost: number
    ) {
        super(
            upgradeResources.assets_views_upgrade_button_button_green_without_shadow_png,
            StringFormatExtention.formatWithComma(coinsCost),
            new UpgradeButtonTextStyle(),
            upgradeResources.assets_views_upgrade_button_button_coin_icon_png);
        this.upgradeResources = upgradeResources;
        this.updateIconByUpgradeStateType(upgradeStateType);
    }

    public updateIconByUpgradeStateType(upgradeStateType: UpgradeStateType): void {
        switch (upgradeStateType) {
            case UpgradeStateType.FIX:
                this.defaultView.texture = this.upgradeResources.assets_views_upgrade_button_button_orange_without_shadow_png;
                break;
            case UpgradeStateType.LOCKED:
                this.defaultView.texture = this.upgradeResources.assets_views_upgrade_button_button_green_without_shadow_png;
                break;
            case UpgradeStateType.AVAILABLE:
                this.defaultView.texture = this.upgradeResources.assets_views_upgrade_button_button_green_without_shadow_png;
                break;
        }
    }

    public updateCostValue(cost: number): void {
        this.buttonText = StringFormatExtention.formatWithComma(cost);
        this.updateTextAndIconPositions();
    }
}

class UpgradeButtonTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            align: "center",
            fill: "#ffffff",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 52
        }));
    }
}
